import InterfaceSearch from '@streamlinehq/streamlinehq/img/streamline-mini-line/interface-essential/search/interface-search.svg';
import { components, ValueContainerProps } from 'react-select';
import styled from 'styled-components';
import { ModelEntitySearchResponseItem } from '../../../../../../common/model/search/types';
import { BouSvgIcon } from '../../../../generic/components/bou-svg-icon';
import { getTextStyle } from '../../../../generic/content/texts/bou-text/text-style';
import { BouColor } from '../../../../generic/global/bou-colors';

export function CustomValueContainer<IsMulti extends boolean>(
  props: ValueContainerProps<ModelEntitySearchResponseItem, IsMulti>,
) {
  return (
    <Root {...props}>
      <Main>
        <ChildContainer>{props.children}</ChildContainer>
        <Icon icon={<InterfaceSearch />} />
      </Main>
    </Root>
  );
}

/**
 * Value container for the "input-like" search variant (see `inputLikeSearchStyles`
 * in ./styles). Same layout + search icon as {@link CustomValueContainer}, but
 * without the bespoke bottom underline and bottom-aligned text — so the field
 * reads as a standard, vertically-centered text input. Pass via
 * `components={{ ValueContainer: InputLikeValueContainer }}`.
 */
export function InputLikeValueContainer<IsMulti extends boolean>(
  props: ValueContainerProps<ModelEntitySearchResponseItem, IsMulti>,
) {
  return (
    <Root {...props}>
      <InputLikeMain>
        <ChildContainer>{props.children}</ChildContainer>
        <InputLikeIcon icon={<InterfaceSearch />} />
      </InputLikeMain>
    </Root>
  );
}

const Root = styled(components.ValueContainer)`
  padding: 0 !important;
  height: 100%;
  display: flex;
` as typeof components.ValueContainer;

const Main = styled.div`
  display: flex;
  align-items: center;
  align-self: flex-end;
  justify-content: space-between;
  width: 100%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  ${getTextStyle({ size: 'xsmall' })}
`;

const InputLikeMain = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  ${getTextStyle({ size: 'xsmall' })}
`;

const ChildContainer = styled.div`
  display: flex;
  align-items: center;
`;

const Icon = styled(BouSvgIcon)`
  margin-left: 1em;
  margin-right: 0.2em;
  padding-bottom: 0.5em;
  color: ${BouColor.PLATFORM_ICON_GRAY};
  transform: scaleX(-1);
`;

const InputLikeIcon = styled(BouSvgIcon)`
  margin-left: 1em;
  margin-right: 0.2em;
  color: ${BouColor.PLATFORM_ICON_GRAY};
  transform: scaleX(-1);
`;
